<template>
    <div>
        <header-vue></header-vue>
        <div style="height: 40px"></div>
        <div class="banner">
            <div class="card rounded-0 g-mb-10">
            <div class="card-block">
                <p class="card-text">
                    全日本通商株式会社（以下「当社」）は、以下のとおり個人情報保護方針を定め、個人情報保護の仕組みを構築し、提供いただく個人情報に関し、関係法令に基づき弊社が厳正に運用することを宣言するものです。この宣言を弊社のプライバシーポリシーとしてご案内させていただきます。。
                </p>
                <p class="card-text">1） 個人情報管理
                    個人情報の取得、利用および提供を適切に行ない、個人情報を正確かつ最新の状態に保ち、個人情報の漏えいや不正アクセス、滅失、またはき損等のリスクに関して、安全管理に必要かつ適切な措置を講じるため、個人情報保護マネジメントシステムを確立し、これを遵守するため、社内管理体制の整備、教育の徹底等、必要な措置を講じます。
                    万が一、問題が発生した場合には、被害の拡大防止に努め、速やかに是正措置を実施します。
                </p>
                <p class="card-text">2） 個人情報の取得および利用範囲
                    個人情報を取得および利用する場合には、利用目的を明確にし、ご本人に同意をいただいて特定された利用目的の達成に必要な範囲内で、適切に個人情報を取扱います。
                    お客様からご提供いただいた個人情報は、以下に明示させていただく利用目的の範囲内で利用します。
                </p>
                <ul>
                    <li>
                        お問い合わせ・ご相談への対応
                    </li>
                    <li>
                        弊社が運営する店舗店頭及び買取・販売による商品発送、メルマガ配信業務のため
                    </li>
                    <li>
                        買取による端末に関するご連絡のため
                    </li>
                    <li>
                        弊社が運営する通信買取の見積及び注文時のお客様配送先（古物業法に基づく法令順守の本人確認手続きを含む）確認のため
                    </li>
                    <li>
                        その他 の弊社の行う業務のみに使用し他の目的には一切使用いたしません。
                    </li>
                </ul>
                <p class="card-text">
                    3） 個人情報の共同利用
                    個人情報をグループ会社間で共同利用する場合は、共同して利用すること、共同して利用される個人情報の項目、共同して利用する者の範囲、共同して利用する者の利用目的、共同して利用する個人情報の管理について責任を有する者の氏名又は名称、取得方法をあらかじめ適切な方法でご本人へ通知するか、ホームページなどにおいて公表します。
                </p>
                <p class="card-text">
                    4） 個人情報の第三者への開示・提供の禁止、委託先の監督
                    取得した個人情報は適切に管理し、法的義務を伴う官公庁等の公的機関から開示要請を受けた場合、およびあらかじめご本人から同意をいただいた提供先以外の第三者に開示・提供は一切いたしません。
                    また、委託先等に個人情報を開示・提供する場合はあらかじめご本人から同意をいただいたうえで行ない、当該委託先と個人情報の取扱いに関する安全管理措置に必要な契約の締結を行い、定期的な監督を行ないます。
                </p>
                <p class="card-text">
                    5） ご本人の個人情報の照会・問い合わせ
                    個人情報の開示、訂正、追加、削除、消去または利用の停止などを求められる場合、ご本人であることを確認のうえ、個人情報に関するご本人の権利に従い合理的な範囲で対応いたします。
                </p>
                <p class="card-text">
                    6） 法令、規範の遵守と改善
                    個人情報保護に関する法令および国が定める指針、その他規範を遵守すると共に個人情報保護を適切に維持するために、当社は、保有する個人情報に関して適用される日本の法令、その他規範を遵守するとともに、本ポリシーの内容を適宜見直し、その改善に努めます。
                    当社の個人情報の取扱に関するお問い合せは下記までご連絡ください。
                </p>
                <p class="card-text">
                    お問い合わせ：cm770546@yahoo.co.jp<br>
                    LINE予約： @kaitoritopone　|　郵送予約： 03-3894-0908
                </p>
            </div>
        </div>
        </div>

        <FooterVue></FooterVue>
    </div>
</template>

<script>
import HeaderVue from "../components/Header.vue";
import FooterVue from "../components/FFooter.vue";
export default {
    components: { HeaderVue, FooterVue },
    props: {},
    data() {
        return {};
    },
    mounted() { },
    methods: {},
};
</script>
<style scoped>
.banner {
    width: 77vw;
    margin: 0px auto;
    padding: 20px 0;
    box-sizing: border-box;
    color: #555;
}
</style>